import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CONFIRM_RESET_PASSWORD_FAILURE,
  CONFIRM_RESET_PASSWORD_REQUEST,
  CONFIRM_RESET_PASSWORD_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_LOGOUT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_SUCCESS_OTP,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
} from 'signoxe/constants/actionTypes';
import { API_AUTH_ROOT } from 'signoxe/constants/config';
import request from 'superagent';
import fetchAll from './fetchAll';

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem('token')}`;


/**
 * Saves the login details to localstorage so the user remains logged in until explicitly
 * logging out.
 *
 * @param username
 * @param token
 */
function saveLoginToStorage(username, token, multiregion) {
  localStorage.setItem('username', username);
  localStorage.setItem('token', token);
}

/**
 * Sends a login post request.
 *
 * @param username
 * @param password
 */

 export const otpLogin = (code) => (dispatch) => {

  const username = localStorage.getItem('username-otp')

  return request
    .post(`${API_AUTH_ROOT}/token/otp/`)
    .accept('application/json')
    .send({username, code})
    .then(response => {
      console.log(response)
      if (!response.ok) {
        dispatch({type: LOGIN_FAILURE, error: response.body});
        return Promise.reject(response.body);
      }
      return response.body;
    })
    .then(data => {
      saveLoginToStorage(username, data.auth_token);
      dispatch({type: LOGIN_SUCCESS, username, token: data.auth_token, offlineOnly: data.offlineOnly});
      dispatch({type: LOGIN_SUCCESS, username, token: data.auth_token, offlineOnly: data.offlineOnly});
      localStorage.setItem('offlineOnly', data.offlineOnly);
      localStorage.setItem('self_activation', data.self_activation);
      
    })
    .then(() => dispatch(fetchAll()))
    .then(() => ({login: true}))
    .catch(error => dispatch({type: LOGIN_FAILURE, error: error.response.body}));
};


export const loginUser = (username, password) => (dispatch) => {
  dispatch({type: LOGIN_REQUEST, username, password});

  return request
    .post(`${API_AUTH_ROOT}/token/create/`)
    .accept('application/json')
    .send({username, password})
    .then(response => {
      console.log(response)
      if (!response.ok) {
        dispatch({type: LOGIN_FAILURE, error: response.body});
        return Promise.reject(response.body);
      }
      return response.body;
    })
    .then(data => {
      if(!data.auth_token){
        dispatch({type: LOGIN_SUCCESS_OTP, username, message: data.non_field_errors});

        console.log("NEED AN OTP!")
        return Promise.reject(data.non_field_errors);
      }
      saveLoginToStorage(username, data.auth_token);
      dispatch({type: LOGIN_SUCCESS, username, token: data.auth_token, offlineOnly: data.offlineOnly});
      dispatch({type: LOGIN_SUCCESS, username, token: data.auth_token, offlineOnly: data.offlineOnly});
      localStorage.setItem('offlineOnly', data.offlineOnly);
      localStorage.setItem('self_activation', data.self_activation);
      localStorage.setItem('is_checker', data.is_checker);
      localStorage.setItem('loggedInUserId', data.userId);
      localStorage.setItem('alias', data.alias);
    })
    .then(() => dispatch(fetchAll()))
    .then(() => ({login: true}))
    .catch(error => dispatch({type: LOGIN_FAILURE, error: error.response.body}));
};

/**
 * Sends a logout post request.
 *
 */
export const logoutUser = () => dispatch => {
  dispatch({type: LOGIN_LOGOUT});
  request.post(`${API_AUTH_ROOT}/logout/`)
         .accept('application/json')
         .set('Authorization', getAuthTokenHeader())
         .end();
  localStorage.removeItem('username');
  localStorage.removeItem('token');
  localStorage.removeItem('loggedInUserId');
  localStorage.removeItem('alias');
  localStorage.removeItem('max_uploadable_asset_size');
};

export const changePassword = (currentPassword, newPassword) => dispatch => {
  dispatch({type: CHANGE_PASSWORD_REQUEST});

  return request
    .post(`${API_AUTH_ROOT}/password/`)
    .accept('application/json')
    .set('Authorization', getAuthTokenHeader())
    .send({current_password: currentPassword, new_password: newPassword})
    .then(response => {
      if (!response.ok) {
        const errorMsg = response.body;

        dispatch({type: CHANGE_PASSWORD_FAILURE, error: errorMsg});

        return Promise.reject(errorMsg);
      }
      dispatch({type: CHANGE_PASSWORD_SUCCESS});
    })
    .catch(error => dispatch({
      type: CHANGE_PASSWORD_FAILURE,
      error: error.response.body,
    }));
};

export const resetPassword = (email) => dispatch => {
  dispatch({type: RESET_PASSWORD_REQUEST});

  return request
    .post(`${API_AUTH_ROOT}/password/reset/`)
    .accept('application/json')
    .send({email})
    .then(response => {
      if (!response.ok) {
        const errorMsg = response.body.email[0];

        dispatch({type: RESET_PASSWORD_FAILURE, error: errorMsg});

        return Promise.reject(errorMsg);
      }
      dispatch({type: RESET_PASSWORD_SUCCESS});
    })
    .catch(error => {
      dispatch({
      type: RESET_PASSWORD_FAILURE,
      error: error.response.body.email[0],
    })});
};

export const resetPasswordConfirm = (uid, token, newPassword) => dispatch => {
  dispatch({type: CONFIRM_RESET_PASSWORD_REQUEST});

  return request
    .post(`${API_AUTH_ROOT}/password/reset/confirm/`)
    .accept('application/json')
    .send({uid, token, new_password: newPassword})
    .then(response => {
      if (!response.ok) {
        const errorMsg = response.body;

        dispatch({type: CONFIRM_RESET_PASSWORD_FAILURE, error: errorMsg});

        return Promise.reject(errorMsg);
      }
      dispatch({type: CONFIRM_RESET_PASSWORD_SUCCESS});
    })
    .catch(error => dispatch({
      type: RESET_PASSWORD_FAILURE,
      error: error.response.body,
    }));
};


export const loginWithLink = (code) => dispatch => {
  localStorage.removeItem('token');
  dispatch({type: LOGIN_REQUEST});

  return request
    .post(`${API_AUTH_ROOT}/token/one-time-link/`)
    .accept('application/json')
    .send({code})
    .then(response => {
      if (!response.ok) {
        const errorMsg = response.body;

        dispatch({type: LOGIN_FAILURE, error: errorMsg});

        return Promise.reject(errorMsg);
      }
      saveLoginToStorage(response.body.username, response.body.auth_token);
      dispatch({type: LOGIN_SUCCESS, username: response.body.username, token: response.body.auth_token, offlineOnly: data.offlineOnly});
      dispatch({type: LOGIN_SUCCESS, username: response.body.username, token: response.body.auth_token, offlineOnly: data.offlineOnly});
      localStorage.setItem('offlineOnly', data.offlineOnly);
      localStorage.setItem('self_activation', data.self_activation);
      
    })
    .then(() => dispatch(fetchAll()))
    .then(() => ({login: true}))
    .catch(error => dispatch({
      type: LOGIN_FAILURE,
      error: error.response.body,
    }));
};


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/login.js